import { render } from "./About.vue?vue&type=template&id=01dee5eb&scoped=true&bindings={}"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=01dee5eb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-01dee5eb"

export default script